import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/navbar/navbar.comp";
import "./home.style.scss";
import ChallengeCard from "../../components/challengeCard/challengeCard.comp";
import { getFeaturedChallenges } from "../../utils/firebase/firebase.utils";
import { useChallenge } from '../../contexts/challenges.context';
import Footer from "../../components/footer/footer.comp";
import Card from "../../components/card.comp";
import logo from '../../assets/logo.png';

const Home = () => {

    //INPUTS
    const navigate = useNavigate();
    const { setSelectedChallenge } = useChallenge();

    // [1] GET Challenges
    const [challengesLoaded, setChallengesLoaded] = useState(false)
    const [challenges, setChallenges] = useState([]);
    useEffect(() => {
        const timer = setTimeout(async () => {
            const fetchChallenges = async () => {
                try {
                    const loadedChallenges = await getFeaturedChallenges();
                    console.log('Fetched this: ', loadedChallenges)
                    setChallenges(loadedChallenges);
                    setChallengesLoaded(true); // Move this here after challenges are set
                } catch (error) {
                    console.error('Error loading challenges:', error);
                    // Optionally handle the error
                }
            };

            fetchChallenges();
        }, 200);

        return () => clearTimeout(timer);

    }, []);

    // [2] SEARCH BAR
    const [searchValue, setSearchValue] = useState("");
    const handleClearSearch = () => {
        setSearchValue('')
    }

    // [3] NAVIGATING
    const handleChallengeClick = (challenge) => {
        setSelectedChallenge(challenge);
        navigate(`/challenge/${challenge.id}`);
    };


    return (
        <div>

            {/* Navbar */}
            <Navbar option={0} homePage={true} />

            <Card
                image={logo}
                title={'Reach'}
                desc={'Fun uplifting challenges'}
                imageHeight={'100px'}
                imageWidth={'100px'}
                onClick={() => window.open('https://enmg-d2c6f.web.app/', '_blank')}
            />

            {/* Search Bar */}
            <div
                className="frame"
                style={{
                    margin: '0 auto 32px',
                }}
            >
                <div style={{
                    display: 'flex',
                    alignItems: "center",
                    gap: '4px'
                }}>
                    <input
                        type="text"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        placeholder="Discover Fun and Easy Challenges!"
                        style={{
                            padding: "8px",
                            flex: 1
                        }}
                    />
                    {searchValue && (
                        <div style={{
                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            height: '32px',
                            width: '32px',
                            cursor: 'pointer'
                        }}
                            onClick={handleClearSearch}
                        />
                    )}
                </div>
            </div>

            {/* Challenges*/}
            {challengesLoaded && challenges.length > 0 ? (
                <div className="frame card-display">
                    {challenges.filter((challenge) => {
                        const lowerCaseSearchValue = searchValue.toLowerCase();

                        // Check if the challenge or its channel matches the search value
                        return (
                            challenge.title.toLowerCase().includes(lowerCaseSearchValue) ||
                            (challenge.subtitle && challenge.subtitle.toLowerCase().includes(lowerCaseSearchValue)) ||
                            (challenge.about && challenge.about.toLowerCase().includes(lowerCaseSearchValue))
                        );
                    })
                        .map((challenge, index) => {
                            if (challenge.publicFlag !== false) {

                                return (
                                    <ChallengeCard
                                        id={challenge.id}
                                        channelID={challenge.channelID}
                                        key={index}
                                        imageURL={challenge.imageURL}
                                        title={challenge.title}
                                        eventTime={challenge.eventTime}
                                        eventsTotal={challenge.eventsTotal}
                                        weeks={challenge.weeks}
                                        about={challenge.about}
                                        info={challenge.info}
                                        onClick={() => handleChallengeClick(challenge)}
                                        video={challenge.videoURL}
                                        videoURL={challenge.videoURL}
                                        challengesLoaded={challengesLoaded}
                                        noProfileImage={true}
                                    />
                                );
                            }
                            return null; // Prevent React warning about missing return in map
                        })
                    }
                </div>
            ) : (
                <div className="loading-circle" />
            )}

            {/* Space */}
            <div style={{
                display: 'flex',
                justifyContent: "center",
                alignItems: "center",
                marginTop: '180px',
                marginBottom: '80px',
            }} />

            <Footer />

        </div>
    );
};

export default Home;